<template>
  <img :src="imageUrl" :class="cssClass" />
</template>

<script lang="ts" setup>
import FileService from "~/core/services/FileService";
const props = defineProps({
  filePath: {
    type: String,
    required: false,
  },
  cssClass: {
    type: String,
    required: false,
  },
});
const config = useRuntimeConfig();

const imageUrl = computed(() => {
  // if (props.filePath?.startsWith("http")) {
  //   return props.filePath;
  // } else {
  //   return (
  //     config.public.apiBaseUrl +
  //     "/api/v1/file-upload/display?filePath=" +
  //     props.filePath
  //   );
  // }
  return new FileService().getFileFullPath(props.filePath ?? "");
});
</script>
